

























import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class AppCard extends Vue {
  @Prop() text: Boolean;
  @Prop({ default: false }) noPadding: Boolean;
  @Prop({ default: false }) noBottomRadius: Boolean;
  @Prop({ default: false }) noTopRadius: Boolean;

  get isNoPadding() {
    return this.noPadding;
  }

  get hasFooterSlot() {
    return this.$slots.footer;
  }

  get hasHeaderSlot() {
    return this.$slots.header;
  }
}
